import React, { useEffect, useState } from "react";
import Layout from "../../shared/Layout";
import Challenge from "./Components/Challenge";
import ScrollToTop from "../../shared/utils/ScrollToTop";
import WhyJoin from "./Components/WhyJoin";
import OurSolution from "./Components/OurSolution";
import Modal from "../../shared/Modal";
import { BsBook } from "react-icons/bs";
import { AiOutlineQuestionCircle } from "react-icons/ai";
import HomeTimeline from "./Components/HomeTimeline";

export default function Program() {
  const [showModal, setShowModal] = useState(false);
  const [solutionObj, setSolutionObj] = useState({});

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <>
      <Layout>
        <Challenge />
        <WhyJoin />
        <OurSolution
          setSolutionObj={setSolutionObj}
          setShowModal={setShowModal}
        />
        <HomeTimeline />
        {/* <TestingBlog /> */}
      </Layout>
      {showModal && (
        <Modal setShowModal={setShowModal}>
          <div className="w-[700px] mx-auto rounded-md overflow-hidden max-h-[800px] overflow-y-scroll">
            <div className="bg-[#EA3352] text-white p-6 text-center text-[25px]">
              {solutionObj.title}
            </div>

            <div className="bg-white text-dark p-6">
              <p className=" text-justify font-ruda leading-8">
                <h6 className="font-bold">
                  <span
                    className="text-pink-600 text-3xl inline-block"
                    style={{
                      position: "relative",
                      top: "9px",
                      "margin-right": "0.5rem",
                    }}
                  >
                    {" "}
                    <AiOutlineQuestionCircle />{" "}
                  </span>
                  {solutionObj?.question}
                </h6>

                <span
                  className="text-pink-600 text-3xl inline-block"
                  style={{
                    position: "relative",
                    top: "9px",
                    "margin-right": "0.5rem",
                  }}
                >
                  {" "}
                  <BsBook />{" "}
                </span>
                {solutionObj?.description}

                <h3 className="mt-4 font-semibold">{solutionObj?.example}</h3>

                <ul>
                  {Object.keys(solutionObj?.links).map((key, index) => (
                    <li>
                      <a
                        href={solutionObj?.links[key]}
                        className="text-sky-700 underline font-semibold"
                        target="_blank"
                      >
                        {key}
                      </a>
                    </li>
                  ))}
                </ul>
              </p>
            </div>
          </div>
        </Modal>
      )}
    </>
  );
}
